import { isValidHouseNumber } from 'app/validators/validateHouseNumber';
import { LabelEnum } from 'app/shared/enums';

export default function validateHouseNumber(value: string) {
  return isValidHouseNumber(value) ? undefined : LabelEnum.InvalidHouseNumber;
}
